import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';

import { Icon } from 'common/icon';
import { EditProfileModal } from 'components/modal/edit-profile';

import { IUser } from 'constants/types';

import { ConfirmModal } from 'components/modal/confirm-modal';
import { EditEmailModal } from 'components/modal/edit-email';
import { UnlinkGoogleConfirmModal } from 'components/modal/edit-profile/unlink-socials-confim';
import { EditUsernameModal } from 'components/modal/edit-username';
import { EditUserPhotoModal } from 'components/modal/edit-userphoto';
import { Routes } from 'constants/routes';

import styles from './styles.module.css';
import { Analytics } from 'constants/analytics';
import { Anchor } from 'constants/anchors';
import Link from 'next/link';
import { useAuth } from 'context/auth';

export const ActionBlockProfile = ({
  user,
  changeLogout,
  chandeEditProfile,
  variant,
}: {
  user?: IUser;
  changeLogout?: (value: boolean) => void;
  chandeEditProfile?: (value: boolean) => void;
  variant?: 'public' | 'private';
}) => {
  console.error(user);
  const handleLogout = () => {
    if (changeLogout) {
      changeLogout(true);
    }
  };

  const handleEditProfile = () => {
    if (chandeEditProfile) {
      chandeEditProfile(true);
    }
  };

  if (variant === 'public') {
    return (
      <div className={styles.profile__actions}>
        <Link
          href={`#${Anchor.CasinoReviews}`}
          className={styles.profile__action}
        >
          <Icon.MessageThird fill="white" width="20" height="20" />
          <span>{`${user?.reviews?.length} reviews`}</span>
        </Link>
        <Link
          href={`#${Anchor.slot.checkRTP}`}
          className={styles.profile__action}
        >
          <Icon.Search />
          <span>{`${user?.slots_reviews?.length} checks`}</span>
        </Link>
        <Link href={`#${Anchor.Topics}`} className={styles.profile__action}>
          <Icon.MessageFourth />
          <span>{`${user?.questions?.length} topics`}</span>
        </Link>
      </div>
    );
  }

  return (
    <div className={styles.profile__actions}>
      <div
        id={Analytics.user.editProfile}
        className={styles.profile__action}
        onClick={handleEditProfile}
      >
        <Icon.Edit />
        <span>{'Edit profile'}</span>
      </div>
      <div className={styles.profile__action} onClick={handleLogout}>
        <Icon.Logout />
        <span>{'Log out'}</span>
      </div>
    </div>
  );
};

export const ProfileSection = ({
  user,
  hasActions,
  variant,
}: {
  user?: IUser;
  hasActions?: boolean;
  variant?: 'public' | 'private';
}) => {
  console.error(user);
  const router = useRouter();
  const { logout } = useAuth();
  const [isLogout, setIsLogout] = useState(false);
  const [isEditProfileVisible, setIsEditProfileVisible] = useState(false);
  const [isEditUsernameVisible, setEditUsernameVisible] = useState(false);
  const [isEditUserPhotoVisible, setEditUserPhotoVisible] = useState(false);
  const [isEditEmailVisible, setEditEmailVisible] = useState(false);
  const [isGoogleUnlinkVisible, setIsGoogleUnlinkVisible] = useState(false);

  const handleEditProfileVisible = () => {
    setIsEditProfileVisible(true);
  };

  const handleCancelEditProfile = () => {
    setIsEditProfileVisible(false);
  };

  const handleCancelLogout = () => {
    setIsLogout(false);
  };

  const handleConfirm = () => {
    logout();
    router.push(Routes.home);
  };

  return (
    <>
      <div className={styles.profile}>
        <div className={styles.container_s}>
          <div className={styles.profile__wrapper}>
            <div className={styles.profile__photo}>
              <Image
                alt="user"
                width={110}
                height={110}
                src={user?.imageUrl ?? ''}
              />
            </div>
            <div className={styles.profile__info}>
              <div className={styles.profile__name}>{user?.username}</div>
              {hasActions && (
                <ActionBlockProfile
                  user={user}
                  changeLogout={setIsLogout}
                  chandeEditProfile={handleEditProfileVisible}
                  variant={variant}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <ConfirmModal
        buttonId={Analytics.user.logout}
        headerTitle="Logout"
        isVisible={isLogout}
        onSubmit={handleConfirm}
        onClose={handleCancelLogout}
        title="Do you want to log out?"
      />

      <UnlinkGoogleConfirmModal
        isVisible={isGoogleUnlinkVisible}
        onClose={() => setIsGoogleUnlinkVisible(false)}
      />

      <EditUserPhotoModal
        data={user}
        isVisible={isEditUserPhotoVisible}
        onClose={() => setEditUserPhotoVisible(false)}
      />

      <EditUsernameModal
        data={user}
        isVisible={isEditUsernameVisible}
        onClose={() => setEditUsernameVisible(false)}
      />

      <EditEmailModal
        data={user}
        isVisible={isEditEmailVisible}
        onClose={() => setEditEmailVisible(false)}
      />

      {variant === 'private' && (
        <EditProfileModal
          data={user}
          onUnlinkGoogle={() => {
            setIsEditProfileVisible(false);
            setIsGoogleUnlinkVisible(true);
          }}
          onEditPhoto={() => {
            setIsEditProfileVisible(false);
            setEditUserPhotoVisible(true);
          }}
          onEditUsername={() => {
            setIsEditProfileVisible(false);
            setEditUsernameVisible(true);
          }}
          onEditEmail={() => {
            setIsEditProfileVisible(false);
            setEditEmailVisible(true);
          }}
          isVisible={isEditProfileVisible}
          onClose={handleCancelEditProfile}
        />
      )}
    </>
  );
};
